import React, { useState, useEffect, useRef } from 'react'; //ai useRef
import ExpandableSection from '../../expandablesection';
import '../../entrydoor.css'; // Import the CSS file for styles
import '../../toolbar.css';
import { authFetch } from '../../utils/api';

const WAppearance = ({config}) => {
    const [controlMap, setControlMap] = useState([]);
    const [appearanceTemplates, setAppearanceTemplates] = useState([]);
    const [displayDebug, setDisplayDebug] = useState(false);

    useEffect(() => {
      async function loadTemplates() {
        try {
          const data = await authFetch(`/appearance-templates/`);
          const testTemplate = getAppearance(data);
          //("✅ Appearance Templates:", JSON.stringify(testTemplate, null, 2));
          setAppearanceTemplates(testTemplate); 
          const enrichedTemplate = testTemplate.map((tpl, index) => ({
            ...tpl,
            type: 'appearanceTemplate',
            expandableSectionId: "Appearance",
            status: "active", // ✅ REQUIRED
            position: [index + 1, 1], // ✅ Vertical layout
            component: <AppearanceTemplateComponent tpl={tpl} />
          }));
 
          
          
    
          ///setControlMap((prev) => [...prev, ...enrichedTemplate]);
          setControlMap(enrichedTemplate); // ✅ Replaces old map, no duplicates

    
        } catch (err) {
          console.error("❌ Failed to fetch templates:", err);
        }
      }
    
      loadTemplates();
    }, []);

    function formatExpressionsForDisplay(obj) {
      if (typeof obj !== 'object' || obj === null) return '';
    
      const cleaned = Object.entries(obj).map(([key, val]) => {
        if (typeof val === 'string') {
          // Clean any over-escaped junk
          const cleanedVal = val
            .replace(/\\\\/g, '\\')     // Double backslashes
            .replace(/\\'/g, "'")       // Escaped single quotes
            .replace(/\\"/g, '"')       // Escaped double quotes
            .replace(/\\n/g, '\n');     // Newlines (optional)
    
          return `  "${key}": ${cleanedVal}`;
        }
        return `  "${key}": ${val}`;
      });
    
      return `{\n${cleaned.join(',\n')}\n}`;
    }
    
    const AppearanceTemplateComponent = ({ tpl }) => {
      const [form, setForm] = useState({
        id: tpl.id,
        product_type: tpl.product_type || '',
        label: tpl.label || '',
        description: tpl.description || '',
        condition: tpl.condition || '',
        template: tpl.template || '',
        //expressions: JSON.stringify(tpl.expressions || {}, null, 2),
        expressions: formatExpressionsForDisplay(tpl.expressions || {}), // 👈 Here
        active: tpl.active ? 'true' : 'false',
        orderPlace: tpl.orderPlace || 0,
      });
    
      const handleChange = (field) => (e) => {
        setForm({ ...form, [field]: e.target.value });
      };
    
      return (
        <div style={{
          padding: '12px',
          border: '1px solid #ccc',
          borderRadius: '6px',
          marginBottom: '16px',
          backgroundColor: '#fdfdfd' //'#fefefe'
        }}>
          <div>
            <label><strong>ID:</strong></label><br />
            <input type="text" value={form.id} onChange={handleChange('id')} style={{ width: '100%' }} />
          </div>
    
          <div>
            <label><strong>Product Type:</strong></label><br />
            <input type="text" value={form.product_type} onChange={handleChange('product_type')} style={{ width: '100%' }} />
          </div>
    
          <div>
            <label><strong>Label:</strong></label><br />
            <input type="text" value={form.label} onChange={handleChange('label')} style={{ width: '100%' }} />
          </div>
    
          <div>
            <label><strong>Description:</strong></label><br />
            <textarea value={form.description} onChange={handleChange('description')} rows="2" style={{ width: '100%' }} />
          </div>
    
          <div>
            <label><strong>Condition:</strong></label><br />
            <textarea value={form.condition} onChange={handleChange('condition')} rows="2" style={{ width: '100%' }} />
          </div>
    
          <div>
            <label><strong>Template:</strong></label><br />
            <textarea value={form.template} onChange={handleChange('template')} rows="3" style={{ width: '100%', fontFamily: 'monospace' }} />
          </div>
    
          <div>
            <label><strong>Expressions:</strong></label><br />
            <textarea value={form.expressions} onChange={handleChange('expressions')} rows="4" style={{ width: '100%', fontFamily: 'monospace' }} />
          </div>
    
          <div>
            <label><strong>Active:</strong></label><br />
            <select value={form.active} onChange={handleChange('active')} style={{ width: '100%' }}>
              <option value="true">✅ Active</option>
              <option value="false">❌ Inactive</option>
            </select>
          </div>
    
          <div>
            <label><strong>Order Place:</strong></label><br />
            <input type="number" value={form.orderPlace} onChange={handleChange('orderPlace')} style={{ width: '100%' }} />
          </div>
        </div>
      );
    };
    
    
    
    function ensureBackticks(str) {
        if (typeof str !== 'string') return str;
        return str.startsWith('`') && str.endsWith('`') ? str : `\`${str}\``;
    }

    function unescapeExpressions(expressions) {
      if (typeof expressions !== 'object' || expressions === null) return expressions;
    
      return Object.fromEntries(
        Object.entries(expressions).map(([k, v]) => {
          if (typeof v === 'string') {
            return [
              k,
              v
                .replace(/\\\\/g, '\\')     // Unescape double backslashes first
                .replace(/\\'/g, "'")      // Replace \' with '
                .replace(/\\"/g, '"')      // (optional) Replace \" with "
                .replace(/\\n/g, '\n')     // (optional) Replace newline chars
            ];
          }
          return [k, v];
        })
      );
    }
    
    
    function safeParseExpressions(raw) {
      try {
        if (!raw) return {};
    
        let json = raw;
    
        if (typeof raw === 'string') {
          // ✅ Fix unescaped single quotes inside backtick-wrapped strings
          json = raw.replace(/`([^`]*)`/g, (match, inner) => {
            const fixedInner = inner.replace(/'/g, "\\'");
            return `\`${fixedInner}\``;
          });
    
          return JSON.parse(json);
        }
    
        if (typeof raw === 'object' && raw !== null) {
          return raw;
        }
    
        console.warn("⚠️ Unknown expressions format:", raw);
        return {};
    
      } catch (err) {
        console.error("❌ Failed to parse/fix expressions:", raw, err);
        return {};
      }
    }
    
    function sanitizeQuotesInsideBackticks(obj) {
      return Object.fromEntries(
        Object.entries(obj).map(([k, v]) => {
          if (typeof v === 'string' && v.startsWith('`') && v.endsWith('`')) {
            // Escape single quotes inside backticks to avoid breaking string parsing
            const inner = v.slice(1, -1).replace(/'/g, "\\'");
            return [k, '`' + inner + '`'];
          }
          return [k, v];
        })
      );
    }
    
    function getAppearance(data) {
        if (!Array.isArray(data)) return [];
      
        return data.map((template, index) => {
          //let expressions = safeParseExpressions(template.expressions);
          let expressions = unescapeExpressions(template.expressions);
          expressions = sanitizeQuotesInsideBackticks(expressions); // 🔧 fix internal quotes

    // ✅ Optionally wrap in backticks (if needed for your system)
    expressions = Object.fromEntries(
      Object.entries(expressions).map(([k, v]) => [k, ensureBackticks(v)])
    );

 
          
      
          return {
            id: template.id,
            id_auto: template.id_auto ?? null,                      // ✅ internal auto ID
            product_type: template.product_type || '',              // ✅ product category
            label: template.label || '',                            // ✅ display label
            description: template.description || '',                // ✅ description
            condition: template.condition?.trim() || 'true',        // ✅ JS condition string
            template: template.template || '',                      // ✅ HTML template
            expressions,
            active: template.active ?? true,                        // ✅ active flag
            orderPlace: template.order_place ?? index + 1,          // ✅ display order
          };
          
        });
      }
      
    async function fetchAppearanceTemplates() {
    try {
        const data = await authFetch(`/appearance-templates/`);
        console.log("✅ Appearance Templates:", JSON.stringify(data, null, 2));

        if (!Array.isArray(data) || data.length === 0) {
        console.warn("❌ No appearance templates found.");
        alert("No appearance templates found.");
        return;
        }

    // Example: Do something with the data
    // setTemplates(data);  // or whatever state you're using

  } catch (error) {
    console.error("🔥 Error fetching appearance templates:", error);
    alert("Failed to fetch appearance templates.");
  }
  return data;
}

    return (
        <>
          <div className='entire-container'>
          <div className="door-container">
            <ExpandableSection 
              title="🛠️ Window controls appearance" 
              panelLocation="2"
              controlMap={controlMap.filter((control) => control.expandableSectionId === "Appearance")}
              state="false"
              numberOfItemsInLine = "1"
            />
            
            {displayDebug && appearanceTemplates.length > 0 && (
                <div style={{ padding: "10px", backgroundColor: "#f6f6f6", border: "1px solid #ddd", marginTop: "10px" }}>
                    <h4>🎨 Appearance Templates</h4>
                    <pre style={{ fontSize: "12px", overflowX: "auto" }}>
                        const testTemplate = {JSON.stringify(appearanceTemplates, null, 2)};
                    </pre>
                </div>
            )}
        </div>
        </div>
        </>
    );
      
}
export default WAppearance;
/*
CREATE TABLE AppearanceTemplates (
    id_auto INT PRIMARY KEY AUTO_INCREMENT,    -- Internal auto-generated ID
    id VARCHAR(100) UNIQUE NOT NULL,           -- Historical/business identifier
    product_type VARCHAR(50) NOT NULL,         -- Product category

    label VARCHAR(255),                        -- Display label
    description TEXT,                          -- Description text

    `condition` TEXT,                          -- JavaScript condition (escaped)
    template TEXT,                             -- HTML template
    expressions TEXT,                          -- JSON object with expression mappings

    active BOOLEAN NOT NULL DEFAULT TRUE,      -- Is template active
    order_place INT                            -- Order in display
);


*/
